module.exports = __webpack_public_path__ + "static/media/looper_1.9a28109b.png";